import AppRoutes from './modules/appRoutes';
import PerfilRoutes from './modules/perfilRoutes';
import MapeamentoRoutes from './modules/mapeamentoRoutes';
import DiagnosticoRoutes from './modules/diagnosticoRoutes';
import DesempenhoRoutes from './modules/desempenhoRoutes';
import MonitoramentoRoutes from './modules/monitoramentoRoutes';
import GerenciamentoRoutes from './modules/gerenciamentoRoutes';

export default [
  ...AppRoutes,
  ...PerfilRoutes,
  ...MapeamentoRoutes,
  ...DiagnosticoRoutes,
  ...DesempenhoRoutes,
  ...MonitoramentoRoutes,
  ...GerenciamentoRoutes,
];
